import * as actionTypes from '../../../Store/Actions/actionTypes';


export const registerModule = (type) =>{
    return {
        type: actionTypes.REGISTER_MODULE,
        data: { type: type }
    }
}

export const addModuleData = (type,data) =>{
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var date = yyyy + '-' + mm + '-' + dd +" "+ today.getHours().toString().padStart(2, '0') + ":" +today.getMinutes().toString().padStart(2, '0');
    data.date = date;
    data.isRead=false;
    
    return {
        type: actionTypes.MODULE_ADD_DATA,
        data: { type: type, data:data }
    }
}

export const updateModuleData = (type,data) =>{
    return {
        type: actionTypes.MODULE_UPDATE_DATA,
        data: { type: type, data:data }
    }
}

export const toggleExpand = (type) => {
    return {
        type: actionTypes.UPDATE_MODULE_EXPAND,
        data: { type: type }
    }
};



